<template>
    <div id="mails">
        <a-spin :spinning="loading">
            <div class="row container" v-if="allMediaCount > 0">
                <div class="attachments" v-for="item of allMedias">
                    <div class="info">
                        <div class="info-item time">{{ getTime(item.created_at) }}</div>
                        <div class="info-item">
                            <span class="label"> Sender: </span><span> {{ item.sender }} </span>
                        </div>
                        <div class="info-item" v-for="to of item.to_list">
                            <span class="label"> To: </span><span> {{ to }} </span>
                        </div>
                        <div v-if="item.cc_list.length > 0" v-for="cc of item.cc_list">
                            <span class="label"> CC: </span><span> {{ cc }} </span>
                        </div>
                        <div v-if="item.bcc_list.length > 0" v-for="bcc of item.bcc_list">
                            <span class="label"> BCC: </span><span> {{ bcc }} </span>
                        </div>
                    </div>
                    <div style="display: flex">
                        <div style="display: flex; flex-direction: column" v-for="attachment of item.attachments">
                            <ImageMessage v-if="attachment.assetType === 'image'" :message="attachment" />
                            <AssetMessage
                                v-if="attachment.assetType === 'asset'"
                                :message="attachment"
                                :extended-style="extendedStyle()"
                                :message-colors="receivedColorsStyle()"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="data-box" v-else>
                <div class="last-session-info">
                    <div class="material-icons" style="font-size: 20px">block</div>
                    <div class="last-session-data" style="margin-top: 5px">{{ $t('visitor.notUserData') }}</div>
                </div>
            </div>
        </a-spin>
    </div>
</template>

<script>
import { log2 } from "../../../../utils/log2";
import { mapActions, mapState } from "vuex";
import UserMailList from "./MailBox.vue";
import AssetMessage from "../../../../components/popup-chat/messages/AssetMessage.vue";
import ImageMessage from "../../../../components/popup-chat/messages/ImageMessage.vue";
import moment from "moment";

const log = log2("Medias");
moment.locale("tr");

export default {
    name: "Medias",
    components: {
        ImageMessage,
        AssetMessage,
        UserMailList,
    },
    props: {
        visitorId: {
            type: String,
        },
    },
    data: () => {
        return {
            loading: false,
            allMediaCount: 0,
            allMedias: [],
            colors: {
                header: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                launcher: {
                    bg: "#4e8cff",
                },
                messageList: {
                    bg: "#ffffff",
                },
                sentMessage: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                receivedMessage: {
                    bg: "#eaeaea",
                    text: "#222222",
                },
                userInput: {
                    bg: "#f4f7f9",
                    text: "#565867",
                },
            },
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            allMailAddresses: (state) => state.mail.allMailAddresses,
        }),
    },
    methods: {
        ...mapActions({
            getUserMediaList: "mail/getUserMediaList",
            getDepartmentMediaList: "mail/getDepartmentMediaList",
        }),
        extendedStyle() {
            return {
                width: "auto",
                minWidth: "125px",
                maxWidth: "calc(100% - 60px) !important",
            };
        },
        receivedColorsStyle() {
            return {
                color: this.colors.receivedMessage.text,
                backgroundColor: this.colors.receivedMessage.bg,
            };
        },
        getTime(date) {
            return moment(date).format("LLL");
        },
    },
    mounted() {
        const departmentMail = this.allMailAddresses.find(
            (email) => email.department && email.department._id === this.$route.params.id
        );

        const type = this.$route.params.type;
        this.loading = true;
        if (type === "user") {
            return this.getUserMediaList({
                mailAddressId: this.$route.params.id,
                pageCount: 1,
                perPage: 20,
            }).then((res) => {
                console.log("getUserMediaList res", res);
                let { result, totalMessageCount } = res;
                this.allMediaCount = totalMessageCount;
                result = result || [];

                this.allMedias = result.map((item) => {
                    item.attachments = item.attachments.map((attachment) => {
                        attachment.assetType = ["jpg", "jpeg", "png"].includes(attachment.ext) ? "image" : "asset";
                        attachment.isMail = true;
                        return attachment;
                    });
                    return item;
                });
                console.log("this.allMedias user new..", this.allMedias);

                this.loading = false;
            });
        } else {
            return this.getDepartmentMediaList({
                departmentName: departmentMail.mail,
                pageCount: 1,
                perPage: 20,
            }).then((res) => {
                console.log("getDepartmentMediaList res", res);
                let { result, totalMessageCount } = res;
                this.allMediaCount = totalMessageCount;
                result = result || [];

                this.allMedias = result.map((item) => {
                    item.attachments = item.attachments.map((attachment) => {
                        attachment.assetType = ["jpg", "jpeg", "png"].includes(attachment.ext) ? "image" : "asset";
                        attachment.isMail = true;
                        return attachment;
                    });
                    return item;
                });

                console.log("this.allMedias new..", this.allMedias);
                this.loading = false;
            });
        }
    },
    watch: {},
};
</script>

<style lang="scss">
#mails {
    padding-top: 20px;
    background-color: #ffffff;
    height: 100%;
    width: 70vw;

    .container {
        margin-left: 10px;

        .attachments {
            margin: 10px;
            display: flex;
            width: 100%;
            flex-direction: column;

            .info {
                flex-direction: column;
                margin-bottom: 50px;

                .info-item {
                    display: flex;
                    align-items: center;
                    margin-bottom: 6px;
                }

                .time {
                    font-weight: 700;
                    font-size: 20px;
                }

                .label {
                    font-weight: 600;
                    font-size: 15px;
                    margin-right: 5px;
                }
            }
        }

        .data-box {
            margin-left: 30px;
            border: 1px solid #dbe1e8;
            border-radius: 4px;
            -webkit-box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
            box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
            padding: 25px;
            display: grid;
            width: 100%;
            min-width: 500px;
            height: 118px;

            .last-session-info {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .last-session-data {
                    color: #bab5b5;
                }
            }
        }
    }
}
</style>
